import { render, staticRenderFns } from "./DigitInput.vue?vue&type=template&id=5a95f43a&"
import script from "./DigitInput.vue?vue&type=script&lang=js&"
export * from "./DigitInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a95f43a')) {
      api.createRecord('5a95f43a', component.options)
    } else {
      api.reload('5a95f43a', component.options)
    }
    module.hot.accept("./DigitInput.vue?vue&type=template&id=5a95f43a&", function () {
      api.rerender('5a95f43a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-types/inputs/DigitInput.vue"
export default component.exports